import { formatRequest } from "../utils/function";
import axiosInstance from "./axiosInstance";

export function createProducts(data) {
  return axiosInstance.post(`products/create`, formatRequest(data));
}

export function updateProducts(data) {
  return axiosInstance.post(`products/update`, formatRequest(data));
}

export function getProductsList(data) {
  return axiosInstance.post(`products/list`, formatRequest(data));
}

export function getProductsDetails(data) {
  return axiosInstance.post(`products/details`, formatRequest(data));
}

export function deleteProducts(data) {
  return axiosInstance.post(`products/delete`, formatRequest(data));
}


